import React from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'

export const AdxEmptyStateV2 = ({ icon, title = 'No data', subtitle, height = '200px' }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      bgcolor: 'white.main',
      gap: 3,
      p: 2,
      width: 1,
      minHeight: height,
    }}
  >
    {icon && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'light-gray-text.main',
          bgcolor: 'gray-background.main',
          borderRadius: '50%',
          width: 100,
          height: 100,
          p: 2,
        }}
      >
        {icon}
      </Box>
    )}
    <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
      <Typography
        sx={{
          textAlign: 'center',
          color: 'light-gray-text.main',
          fontSize: '16px',
          fontWeight: 'bold',
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ textAlign: 'center', color: 'light-gray-text.main', fontSize: '14px' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  </Box>
)

export default AdxEmptyStateV2
